import { BaseDTO } from './basedto';
import { Constants } from '../core/constants';

export class PartInfo extends BaseDTO {
    PartId: number;
    IsCriticalPart: boolean;
    CriticalClass: string;
    PendingProposalId: number;
    ProposalEstimateId: number;
    PartNumber: string;
    PartCategoryId: Number;
    PartCategoryDescription: string;
    SupplierName: string;
    PartDescription: string;
    SupplierId: number;
    SupplierCode: string;
    SourceTypeId: number;
    SourceTypeName: string;
    SourceTypeDescription: string;
    ParentSourceTypeDescription: string;
    ParentSourceTypeId: number;
    POUomCode: string;
    StockUomCode: string;
    Length: number;
    Width: number;
    Height: number;
    Weight: number;
    Material: string;
    HotRequest: boolean;
    constructor() {
        super();
        this.Material = Constants.DEFAULT_PART_MATERIAL;
    }
}
